import { DialogContent, DialogHeading, Typography } from 'omakase';
import { StoreType } from '@tock/shared/utils/connect';
import { WaitlistEntry } from 'state/walkinWaitlist';
import { consumer } from '@tock/coretypes';
import { useInterval, useWillUnmountEffect } from '@tock/hooks';
import { useSelector } from 'react-redux';
import { walkinWaitlistDialogRoot } from 'components/business/walkin-waitlist/walkinWaitlistCssDefs';
import WalkinWaitlistAlertStatus from 'components/business/walkin-waitlist/WalkinWaitlistAlertStatus';
import WalkinWaitlistBusinessHeader from 'components/business/walkin-waitlist/WalkinWaitlistBusinessHeader';

interface Props {
  business: consumer.IBusinessConfig;
  onClose(): void;
  fetchWalkinPartyPosition(foo: WaitlistEntry): void;
  numPartiesAhead: number;
  isNumPartiesAheadRequestInProgress?: boolean;
}

const WalkinWaitlistPartyStatus: React.FunctionComponent<Props> = ({
  onClose,
  business,
  fetchWalkinPartyPosition,
  numPartiesAhead,
  isNumPartiesAheadRequestInProgress = false,
}) => {
  const walkinWaitlistParty = useSelector((state: StoreType) => {
    return business?.id ? state.walkinWaitlist.entries[business.id] : null;
  });

  const cancelRefresh = useInterval(() => {
    if (walkinWaitlistParty) {
      fetchWalkinPartyPosition(walkinWaitlistParty);
    }
  }, 30 * 1000);
  useWillUnmountEffect(() => cancelRefresh());

  return (
    <>
      <DialogHeading id="walkin-waitlist-dialog-title" onClose={onClose}>
        Walk-in waitlist
      </DialogHeading>
      <DialogContent css={walkinWaitlistDialogRoot}>
        <>
          <WalkinWaitlistBusinessHeader business={business} />
          <Typography component="h4" variant="body01Strong">
            You're in line for a table at {business.name}
          </Typography>
          <WalkinWaitlistAlertStatus
            isNumPartiesAheadLoading={isNumPartiesAheadRequestInProgress}
            onWaitlist={true}
            numPartiesAhead={numPartiesAhead}
          />
          <Typography variant="body02" component="p" id="walkin-waitlist-dialog-description">
            You’ll get a text when your table is almost ready. Please ensure you’re in the area and
            ready to be seated when notified. Check in your party when you arrive.
          </Typography>
          <Typography variant="body02" component="p" id="walkin-waitlist-dialog-description">
            If you need to leave the waitlist, follow the instructions in your text confirmation.
          </Typography>
        </>
      </DialogContent>
    </>
  );
};

export default WalkinWaitlistPartyStatus;
